import { FC } from 'react';
import { SearchInput } from '@new/common/ui/SearchInput/SearchInput';

interface AddCourseSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export const AddCourseSearch: FC<AddCourseSearchProps> = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="flex justify-between items-center">
      <SearchInput value={searchQuery} onChange={onSearchChange} placeholder="Search..." />

      {/* <div className='flex items-center gap-1'>
            <Filter size={16} /><span>Filter</span></div> */}
    </div>
  );
};
